<template>
  <div class="fact">
    <form v-if="showingForm && editable">
      <div class="field">
        <label class="cm-label" for="f_header">{{ I18n.t('question_title') }}</label>
        <div>
          <input class="cm-field val-required" type="text" v-model="fact.header_value" id="f_header" required="true" :placeholder="I18n.t('question_title')">
        </div>
      </div>
      <div class="field">
        <label class="cm-label" for="f_text">{{ I18n.t('your_answer') }}</label>
        <div>
          <input class="cm-field val-required" type="text" v-model="fact.text_value" id="f_text" required="true" :placeholder="I18n.t('your_answer')">
        </div>
      </div>
      <div class="form-action-row">
        <input @click.prevent="handleSave" type="submit" class="cm-button save-changes" :value="I18n.t('save')" />
        <button class="cancel-button" type="button" @click="handleCancel">{{ I18n.t("cancel") }}</button>
        <a v-if="isExistingFact" rel="nofollow" data-method="delete" :href="`/companies/${company.id}/facts/${fact.id}`" class="delete-link">
          <span>{{ I18n.t('delete_fact') }}</span>
        </a>
      </div>
    </form>
    <template v-else>
      <div class="fact__header">{{ fact.header_value }}</div>
      <div class="fact__text">
        <span>{{ fact.text_value }}</span>
        <button v-if="editable" @click="toggleForm" class="edit-button ss-icon">compose</button>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    props: ['id', 'companyId', 'header', 'text', 'editable'],
    data () {
      return {
        company: {
          id: this.companyId
        },
        fact: {
          id: this.id,
          header_value: this.header,
          text_value: this.text
        },
        response: null,
        showingForm: false
      }
    },

    computed: {
      isExistingFact () { // as opposed to sample/placeholder facts
        return !!this.fact.id
      },
    },

    methods: {
      toggleForm () {
        this.showingForm = !this.showingForm
      },

      handleSave () {
        if (this.isExistingFact) {
          this.$http.patch('/companies/' + this.company.id, {
            company: {
              facts_attributes: {
                [this.fact.id]: {
                  header: this.fact.header_value,
                  text: this.fact.text_value
                }
              }
            }
          }).then(response => {
            this.response = response
            this.showingForm = false
          }, response => {
            this.response = response
          });
        } else {
          this.$http.post(`/companies/${this.company.id}/facts`, {
            header: this.fact.header_value,
            text: this.fact.text_value
          }).then(response => {
            this.response = response
            this.fact.id = response.body.id
            this.showingForm = false
          }, response => {
            this.response = response
          });
        }
      },

      handleCancel () {
        let oldHeader, oldText;

        if (this.response && this.response.body) {
          if (this.isExistingFact && this.response.body.company) {
            const currentFact = this.response.body.company.facts.find(fact => (
              fact.id === this.fact.id
            ))
            oldHeader = currentFact.header;
            oldText = currentFact.text;
          } else {
            oldHeader = this.response.body.header;
            oldText = this.response.body.text;
          }
        } else {
          oldHeader = this.header;
          oldText = this.text;
        }

        this.fact.header_value = oldHeader;
        this.fact.text_value = oldText

        this.toggleForm();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../components/edit-button';

  .fact {
    .save-changes {
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// app/javascript/company/fact.vue?80fbd476